import {
  type InternalMentionSuggestionsAction,
  internalSuggestionsError,
  internalSuggestionsLoaded,
} from 'common/actions/internalMentionSuggestions';

import type { MentionSuggestion } from 'common/api/endpoints/mentions';

type SuggestionQuery = {
  error: string | null;
  items: MentionSuggestion[] | null;
  lastUpdated: number;
  loading: boolean;
};

export type InternalMentionSuggestionsState = Record<string, SuggestionQuery>;

const initialState: InternalMentionSuggestionsState = {};

export default function internalMentionSuggestions(
  state = initialState,
  action: InternalMentionSuggestionsAction,
): InternalMentionSuggestionsState {
  switch (action.type) {
    case internalSuggestionsLoaded: {
      return {
        ...state,
        [action.key]: {
          error: null,
          lastUpdated: action.timestamp,
          loading: false,
          items: action.suggestions,
        },
      };
    }

    case internalSuggestionsError: {
      return {
        ...state,
        [action.key]: {
          error: action.error,
          lastUpdated: action.timestamp,
          loading: false,
          items: null,
        },
      };
    }

    default:
      return state;
  }
}
